import React,{Component} from 'react';
import { BrowserRouter as Router, Link  } from 'react-router-dom';

class InventoryDisplaySheet extends Component{
    
          
    render() {
        
        return (
            <tr>
                <td>
                    <p>Plain Sheet</p>
                </td>
                <td>
                    <p>SHTS</p>
                </td>
                <td>
                    <p>0.{this.props.sheet.thickness}</p>
                </td>
                <td>
                    <p>{this.props.sheet.dimension}</p>
                </td>
                <td>
                    <p>{this.props.sheet.length}</p>
                </td>           
                <td>
                    <p>{this.props.sheet.color}</p>
                </td>
                <td>
                    <p>{this.props.sheet.count}</p>
                </td>
                <td>
                    <Link to={`inventory/${this.props.index}/out-sheet`} data-toggle="tooltip" className="btn btn-default"> Out</Link>
                    <Link to={`inventory/${this.props.index}/view-sheet`} data-toggle="tooltip" className="btn btn-default"> View</Link>
                </td>
            </tr>	    
        );
    }
}

export default  InventoryDisplaySheet;


// WEBPACK FOOTER //
// ./src/components/InventoryDisplaySheet.js